export class WeChatUserInfo {
    public code?: string | null = '';      // code
    public nickname = '';   // 昵称
    public headimgurl = ''; // 头像
    public openid = '';     // 应用内唯一标识
    public unionid = '';    // 平台内唯一标识

    public initWithURLSearchParams(query: URLSearchParams) {
        this.nickname = query.get('nickname') || '';
        this.headimgurl = query.get('headimgurl') || '';
        this.openid = query.get('openid') || '';
        this.unionid = query.get('unionid') || '';
    }

    public initWithJsonString(jsonString: string) {
        if (!jsonString) {
            return;
        }
        const data = JSON.parse(jsonString);
        if (data) {
            this.nickname = data.nickname;
            this.headimgurl = data.headimgurl;
            this.openid = data.openid;
            this.unionid = data.unionid;
        }
    }

    public toJsonString() {
        return JSON.stringify({
            nickname: this.nickname,
            headimgurl: this.headimgurl,
            openid: this.openid,
            unionid: this.unionid,
        });
    }
}
